// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//     production: false,
//     useSSL: false,
//     forcedTheme: 'vinea',
//     api: {
//         host: 'vinea.test',
//         proto: 'https',
//         client_id: '1',
//         client_secret: '5SYocjnpOAOsSSY3YH6XGMRiVyvS02hMrbd2YQUB',
//     },
//     pusher: {
//         key: 'b078c7aaf977ed0f486c',
//         cluster: 'eu',
//         encrypted: true
//     },
// };


// export const environment = {
//     production: false,
//     useSSL: true,
//     forcedAlias: 'schagen',
//     api: {
//         host: 'api.demo.6am.rentageek.eu',
//         proto: 'https',
//         client_id: '3',
//         client_secret: 'djVXpXBSPg2uVds7M8gYydpNtst4TVh2OCKTIV9t',
//     },
//     pusher: {
//         key: '2c17f730b4d0dbbf656b',
//         cluster: 'eu',
//         encrypted: true
//     },
// };

export const environment = {
    production: false,
    useSSL: true,
    forcedAlias: 'clubadventure',
    appVersion: 'v0.2',
    api: {
        host: 'api.wedaycare.com',
        proto: 'https',
        client_id: '2',
        client_secret: 'djVXpXBSPg2uVds7M8gYydpNtst4TVh2OCKTIV9t',
    },
    pusher: {
        key: '6d309ddd87211bd73a1e',
        cluster: 'eu',
        encrypted: true
    },
};
